import { render, staticRenderFns } from "./PurchaseTrainingForm.vue?vue&type=template&id=44a2f8d8&"
import script from "./PurchaseTrainingForm.vue?vue&type=script&lang=ts&"
export * from "./PurchaseTrainingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports